// src/pages/SidePages/FoldersContainer.tsx

import React, { useEffect, useState } from 'react';
import { Box, Heading, Flex, Text } from '@chakra-ui/react';
import ProjectList from '../../components/folder/FolderList';
import { useTab } from '../../contexts/TabContext';

const JobsManagement: React.FC = () => {
  const { setActiveTab } = useTab();
  const [currentPage] = useState(1);
  const itemsPerPage = 3;

  useEffect(() => {
    setActiveTab('jobs');
  }, [setActiveTab]);

  return (
    <Box maxW="1200px" mx="auto" py={8} px={4}>
      <Flex justify="space-between" align="center" mb={8}>
        <Box>
          <Heading size="lg" color="primary.500" mb={1}>
            Your Dashboard
          </Heading>
          <Text fontSize="sm" color="muted.400">
            Manage your genomics analysis projects
          </Text>
        </Box>
      </Flex>

      <ProjectList currentPage={currentPage} itemsPerPage={itemsPerPage} />
    </Box>
  );
};

export default JobsManagement;
